import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import { usePanels } from "@/composables/usePanels";
import ActivityBar from "@/components/ActivityBar/ActivityBar.vue";
import LoadingSpan from "@/components/LoadingSpan.vue";
import FlexPanel from "@/components/Panels/FlexPanel.vue";
import ToolPanel from "@/components/Panels/ToolPanel.vue";
import StatelessTags from "@/components/TagsMultiselect/StatelessTags.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'PublishedItem',
    props: {
        item: null
    },
    setup(__props) {
        const props = __props;
        const modelTitle = computed(() => {
            var _a, _b;
            const modelClass = (_b = (_a = props.item) === null || _a === void 0 ? void 0 : _a.model_class) !== null && _b !== void 0 ? _b : "Item";
            if (modelClass == "StoredWorkflow") {
                return "Workflow";
            }
            return modelClass;
        });
        const plural = computed(() => {
            if (modelTitle.value === "History") {
                return "Histories";
            }
            return `${modelTitle.value}s`;
        });
        const gravatarSource = computed(() => { var _a; return `https://secure.gravatar.com/avatar/${(_a = props.item) === null || _a === void 0 ? void 0 : _a.email_hash}?d=identicon`; });
        const owner = computed(() => { var _a, _b, _c, _d; return (_d = (_b = (_a = props.item) === null || _a === void 0 ? void 0 : _a.owner) !== null && _b !== void 0 ? _b : (_c = props.item) === null || _c === void 0 ? void 0 : _c.username) !== null && _d !== void 0 ? _d : "Unavailable"; });
        const pluralPath = computed(() => plural.value.toLowerCase());
        const publishedByUser = computed(() => `/${pluralPath.value}/list_published?f-username=${owner.value}`);
        const urlAll = computed(() => `/${pluralPath.value}/list_published`);
        const { showActivityBar, showToolbox } = usePanels();
        return { __sfc: true, props, modelTitle, plural, gravatarSource, owner, pluralPath, publishedByUser, urlAll, showActivityBar, showToolbox, ActivityBar, LoadingSpan, FlexPanel, ToolPanel, StatelessTags };
    }
});
